module.exports = __webpack_public_path__ + "static/media/team2.86c8e6e7.jpg";